import * as React from 'react';
var CheckmarkCircle = function (_a) {
    var title = _a.title, titleId = _a.titleId;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "m13.065 15.258 3.807-6.768-1.744-.98-3.806 6.768-2.57-2.937-1.505 1.318 2.57 2.935a2 2 0 0 0 3.248-.336Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" })));
};
export default CheckmarkCircle;
//# sourceMappingURL=CheckmarkCircle.js.map